/**
 * @file HidChannelFactory.ts
 * @description HID 通道工厂。
 * 根据原生设备形态选择 WebHID 或 NodeHID 实现。
 */

import type { HidChannel } from './HidChannel'
import { WebHidChannel } from './webhid/WebHidChannel'
import { NodeHidChannel } from './nodehid/NodeHidChannel'

/**
 * HID 通道工厂。
 */
export class HidChannelFactory {
  static create(type: string, device?: any): HidChannel {
    if (type === 'HID') {
      // 关键：NodeHID 设备对象有 path，WebHID 设备没有 path。
      if (device && typeof device.path === 'string') {
        return new NodeHidChannel(device)
      }
      return new WebHidChannel(device)
    }

    throw new Error(`Unsupported channel type: ${type}`)
  }
}
